import React from 'react';
import { ApiLogEntry } from '../types';

interface ApiLogPanelProps {
  logs: ApiLogEntry[];
  onClear: () => void;
}

const formatTime = (timestamp: number): string => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString('en-US', { hour12: false }) + '.' + date.getMilliseconds().toString().padStart(3, '0');
};

export const ApiLogPanel: React.FC<ApiLogPanelProps> = ({ logs, onClear }) => {
  return (
    <div className="api-log-card">
      <div className="card-header">
        <div>
          <h2>API Call Logs</h2>
          <p className="card-subtitle">Shows each API call, response and status</p>
        </div>
        <button className="ghost-button" onClick={onClear} disabled={logs.length === 0}>
          Clear
        </button>
      </div>
      <div className="api-log-list">
        {logs.length === 0 ? (
          <div className="empty-state">No API calls yet.</div>
        ) : (
          logs.map((log) => (
            <div key={log.id} className={`api-log-item level-${log.level}`}>
              <div className="api-log-meta">
                <span className="api-log-time">{formatTime(log.timestamp)}</span>
                <span className="api-log-title">{log.title}</span>
              </div>
              <div className="api-log-message">{log.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

